import { createClient } from '@supabase/supabase-js';
import AppConst from './constants/app.constant';
import SupabaseConst from './constants/supabase.constant';
import { getEnv, ENVIRONMENT } from './services/getEnv';
import { Preferences } from '@capacitor/preferences';
import reportError from './services/error-handler/reportError';

export const getDerivedSupabaseConfig = () => {
  const env = getEnv();
  if (env === ENVIRONMENT.TEST || env === ENVIRONMENT.LOCAL) {
    return SupabaseConst.dev;
  }
  return SupabaseConst.prod;
};

const getSupabaseConfigForConnection = () => {
  const supaApiKey = localStorage.getItem(
    AppConst.localstorageConf.prefix + AppConst.localstorageConf.supaApiKey,
  );
  const supaApiUrl = localStorage.getItem(
    AppConst.localstorageConf.prefix + AppConst.localstorageConf.supaApiUrl,
  );
  const derivedSupaConfig = getDerivedSupabaseConfig();
  // prefer localstorage value otherwise derived config
  return {
    endpoint: supaApiUrl || derivedSupaConfig.endpoint,
    key: supaApiKey || derivedSupaConfig.key,
  };
};

const supabaseConfig = getSupabaseConfigForConnection();

const capacitorStorage = {
  getItem: async key => {
    const { value } = await Preferences.get({ key });
    return value;
  },
  setItem: async (key, value) => {
    await Preferences.set({ key, value });
  },
  removeItem: async key => {
    await Preferences.remove({ key });
  },
};

const initSupaClient = () => {
  try {
    return createClient(supabaseConfig.endpoint, supabaseConfig.key, {
      auth: {
        storage: capacitorStorage,
        //storageKey: 'supabase_auth',
        autoRefreshToken: true,
        persistSession: true,
        detectSessionInUrl: false,
      },
    });
  } catch (ex) {
    reportError(ex);
    console.error(ex);
  }
};

export const supabase = initSupaClient();
